import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { NavButton } from 'components/Button'

const DeliveryScheduleCollectiveEditCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/clock.svg'} alt={'お届け可能日の設定が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          お届け可能日の設定が
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default DeliveryScheduleCollectiveEditCompleteTemplate
